module.exports = __webpack_public_path__ + "img/营销伙伴09.bd68bc8e.png";